import { makeStyles } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import BaseWidget from '../../components/common/BaseWidget'
import EngagementWidget from '../../components/common/EngagementWidget/EngagementWidget'
import { CopilotEngagementTypes } from 'consts/copilotControlConsts'
import { useFetchScanningScheduleAggregationQuery } from 'store/modules/CopilotControl'
import useCopilotAccountOwnerId from 'components/CopilotControl/hooks/useCopilotAccountOwnerId'

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1
  }
}))

const ScanningSchedule = ({ onChangePatientsListType, isSelected }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const accountOwnerId = useCopilotAccountOwnerId()

  const { data: scanningScheduleData = {}, isLoading } = useFetchScanningScheduleAggregationQuery(
    { accountOwnerId },
    { skip: !accountOwnerId }
  )

  return (
    <BaseWidget carousel={false} className={classes.root} isSelected={isSelected} removePadding>
      <EngagementWidget
        isLoading={isLoading}
        title={t('pages.copilotControl.widgets.scanningSchedule.title')}
        values={scanningScheduleData}
        engagementType={CopilotEngagementTypes.ScanningSchedule}
        onChangePatientsListType={onChangePatientsListType}
      />
    </BaseWidget>
  )
}

export default ScanningSchedule
